import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import {
    setModoTela,
    initForm
} from './usuarioActions';

let UsuarioForm = props => {

    const formulario = props.formularioValues || {};
    const readOnly = props.excluir ? 'readOnly' : '';

    const podeEditarNome = !formulario.id || props.configuracao;
    const podeEditarPerfis = !formulario.id || props.configuracao;
    const modoAlterarSenha = props.modoTela === 'alterarsenha';

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    <Row>
                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Nome *'
                            placeholder='Informe o Nome'
                            cols='12 12 12 12'
                            readOnly={podeEditarNome ? readOnly : 'readOnly'}
                        />

                        <Field
                            name='email'
                            component={LabelAndInput}
                            label='E-mail *'
                            placeholder='Informe o E-mail'
                            cols='12 12 12 12'
                            readOnly={formulario.id ? 'readOnly' : readOnly}
                        />

                        {!props.configuracao &&
                            <Field
                                name='senha'
                                component={LabelAndInput}
                                type='password'
                                label='Senha *'
                                placeholder='Informe a Senha'
                                cols='12 12 12 12'
                                readOnly={readOnly}
                            />}

                        {podeEditarPerfis &&
                            <Select
                                name='ids_perfis'
                                options={props.listaPerfil || []}
                                label='Perfis de Acesso'
                                cols='12 12 12 12'
                                placeholder='Selecione'
                                readOnly={readOnly}
                                multiple
                                value={formulario.ids_perfis}
                                onChange={values => {
                                    props.initForm({
                                        ...formulario,
                                        ids_perfis: (values || []).map(item => item.value)
                                    });
                                }}
                            />}
                    </Row>

                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoTela('lista')}
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text={modoAlterarSenha ? 'Alterar Senha' : 'Salvar'}
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

UsuarioForm = reduxForm({
    form: 'usuarioForm',
    destroyOnUnmount: false
})(UsuarioForm);

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.usuario.modoTela,
    formularioValues: getFormValues('usuarioForm')(state),
    registro: state.usuario.registro,
    listaPerfil: state.usuarioPerfil.listaSelect
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm);